export type CountryLocaleMapping = {
  /**
   * @example "zh-tw"
   */
  locale: string;
  /**
   * @example ["TW"]
   */
  identifier: ReadonlyArray<string>;
  /**
   * @example "JP"
   */
  fallback: string;
};

export const countryLocaleMapping: CountryLocaleMapping[] = [
  { locale: 'ja-jp', identifier: ['JP'], fallback: 'JP' },
  { locale: 'zh-tw', identifier: ['TW'], fallback: 'TW' },
  //  { locale: 'ru-ru', identifier: ['RU'] },
  { locale: 'de-de', identifier: ['DE', 'CH', 'AT'], fallback: 'DE' },
  { locale: 'ko-kr', identifier: ['KR'], fallback: 'KR' },
  { locale: 'fr-fr', identifier: ['FR'], fallback: 'FR' },
  { locale: 'it-it', identifier: ['IT'], fallback: 'IT' },
  { locale: 'zh-cn', identifier: ['CN', 'HK'], fallback: 'CN' },
  {
    locale: 'en-us',
    identifier: [
      'KI',
      'GP',
      'VG',
      'PE',
      'PA',
      'UY',
      'PN',
      'GD',
      'MX',
      'AG',
      'PY',
      'CA',
      'BQ',
      'BL',
      'NI',
      'BZ',
      'US',
      'MS',
      'SV',
      'KN',
      'KY',
      'MQ',
      'VC',
      'SC',
      'VE',
      'PM',
      'MF',
      'LC',
      'SH',
      'GY',
      'GT',
      'JM',
      'EC',
      'GF',
      'BS',
      'TC',
      'HM',
      'HT',
      'TT',
      'CU',
      'BB',
      'BM',
      'FK',
      'BR',
      'SB',
      'CW',
      'DM',
      'CO',
      'DO',
      'MU',
      'CR',
      'CL',
      'AI',
      'AR',
      'BO',
      'AW',
      'SX',
      'SR',
      'GS',
      'BV'
    ],
    fallback: 'US'
  },
  {
    locale: 'en-sg',
    identifier: [
      'YT',
      'KM',
      'CX',
      'IO',
      'KH',
      'WF',
      'MM',
      'VN',
      'ML',
      'VU',
      'TV',
      'TO',
      'TL',
      'TK',
      'AU',
      'TH',
      'PH',
      'PG',
      'SG',
      'KP',
      'RE',
      'WS',
      'NZ',
      'NF',
      'NU',
      'NR',
      'NC',
      'MY',
      'MN',
      'MG',
      'MO',
      'MV',
      'ID',
      'LA',
      'HN',
      'CK',
      'CC',
      'TF',
      'PF',
      'FJ',
      'BT',
      'AQ',
      'VN'
    ],
    fallback: 'SG'
  },
  {
    locale: 'en',
    identifier: [
      'ZW',
      'YE',
      'MW',
      'CD',
      'BY',
      'UA',
      'AM',
      'BI',
      'ZM',
      'SY',
      'SO',
      'SD',
      'SS',
      'BJ',
      'EH',
      'AZ',
      'UZ',
      'MK',
      'LB',
      'LY',
      'IQ',
      'IR',
      'AF',
      'GB',
      'GW',
      'GN',
      'ER',
      'AE',
      'UG',
      'TM',
      'TR',
      'TG',
      'TZ',
      'TJ',
      'SL',
      'SK',
      'SE',
      'SZ',
      'LR',
      'SJ',
      'ST',
      'ES',
      'SI',
      'QA',
      'PL',
      'ZA',
      'NL',
      'MZ',
      'RO',
      'OM',
      'RS',
      'SN',
      'SM',
      'PT',
      'SA',
      'RW',
      'MR',
      'MT',
      'NO',
      'NG',
      'NE',
      'NA',
      'MC',
      'ME',
      'MD',
      'LU',
      'LT',
      'LI',
      'LS',
      'JE',
      'GA',
      'EE',
      'KG',
      'IL',
      'IS',
      'GH',
      'LV',
      'KZ',
      'KW',
      'JO',
      'GL',
      'FI',
      'KE',
      'IE',
      'GR',
      'GE',
      'HU',
      'GQ',
      'DJ',
      'IM',
      'GI',
      'GM',
      'ET',
      'VA',
      'GG',
      'BF',
      'AX',
      'DK',
      'HR',
      'EG',
      'CY',
      'BN',
      'FO',
      'CV',
      'TD',
      'CZ',
      'CM',
      'BE',
      'BG',
      'BW',
      'BA',
      'AO',
      'CF',
      'BH',
      'AD',
      'DZ',
      'AL',
      'TN',
      'AN',
      'AS',
      'CI',
      'FM',
      'GU',
      'MA',
      'PR',
      'PS',
      'PW',
      'VI',
      'CG',
      'MH',
      'MP',
      'UM',
      'XK',
      'DE',
      'AT',
      'CH',
      'RU',
      'IN',
      'PK',
      'NP',
      'LK',
      'BD'
    ],
    fallback: 'GB'
  }
];
